import { defineStore } from 'pinia'
import { ref } from "vue";
import { request } from "@/ts/request";
import { RequestStatus } from "@/ts/interfaces/requests/statusEnum"

const basePathName = '/api/project'

const routes = {
    'index': '/',
}

export const useProjectIndexStore = defineStore('project_index', () => {
    const projects = ref<object>([])

    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    async function listProjects() {
        status.value = RequestStatus.LOADING

        const response = await request(`${basePathName}${routes.index}`, {
            method: 'GET'
        })

        if(response.ok) {
            status.value = RequestStatus.SUCCESS
            projects.value = await response.json()
        }
    }

    return { projects, status, listProjects }
})